import ArticleIcon from '@mui/icons-material/Article';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import HomeIcon from '@mui/icons-material/Home';
import PhotoLibraryOutlinedIcon from '@mui/icons-material/PhotoLibraryOutlined';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    BLOG_PATH,
    CONTACT_PATH,
    PATHFINDER_PROJECT_PATH,
    PHOTOS_PATH,
    SORTING_ALG_PROJECT_PATH,
    TREE_PROJECT_PATH,
} from '../constants';

interface DrawerProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const PAGES = ['Home', 'Journal', 'Photos', 'Contact'];
const PAGE_ROUTES = ['/', `/${BLOG_PATH}`, `/${PHOTOS_PATH}`, `/${CONTACT_PATH}`];
const PAGE_ICONS = [
    <HomeIcon sx={{ color: '#1e4f9b' }} />,
    <ArticleIcon sx={{ color: '#1e4f9b' }} />,
    <PhotoLibraryOutlinedIcon sx={{ color: '#1e4f9b' }} />,
    <ContactMailIcon sx={{ color: '#1e4f9b' }} />,
];
const PROJECTS = ['Pathfinder', 'Binary Tree Traverser', 'Sorting Algorithm Visualizer'];
const PROJECT_IMAGES_PATHS = [
    `${process.env.PUBLIC_URL}/graph.webp`,
    `${process.env.PUBLIC_URL}/binary-tree.webp`,
    `${process.env.PUBLIC_URL}/array.webp`,
];
const PROJECT_ROUTES = [`/${PATHFINDER_PROJECT_PATH}`, `/${TREE_PROJECT_PATH}`, `/${SORTING_ALG_PROJECT_PATH}`];

export function TemporaryDrawer(props: DrawerProps) {
    const navigate = useNavigate();
    const [projectsOpen, setProjectsOpen] = React.useState(false);

    const toggleDrawer = (newOpen: boolean) => () => {
        props.setOpen(newOpen);
        if (!newOpen) {
            setProjectsOpen(false);
        }
    };

    function handleNavigate(path: string) {
        props.setOpen(false);
        navigate(path);
    }

    const DrawerList = (
        <Box sx={{ width: 260, backgroundColor: '#f6faff', height: '100%' }} role="presentation">
            <List>
                {PAGES.map((text, index) => (
                    <React.Fragment key={text}>
                        <ListItem disablePadding onClick={() => handleNavigate(PAGE_ROUTES[index])}>
                            <ListItemButton sx={{ color: '#1e4f9b' }}>
                                <ListItemIcon>{PAGE_ICONS[index]}</ListItemIcon>
                                <ListItemText primary={text} />
                            </ListItemButton>
                        </ListItem>
                        {text === 'Photos' && (
                            <>
                                <ListItem disablePadding>
                                    <ListItemButton sx={{ color: '#1e4f9b' }} onClick={() => setProjectsOpen((previous) => !previous)}>
                                        <ListItemIcon>
                                            <FolderOpenOutlinedIcon sx={{ color: '#1e4f9b' }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Projects" />
                                        {projectsOpen ? (
                                            <ExpandLessIcon sx={{ color: '#1e4f9b' }} />
                                        ) : (
                                            <ExpandMoreIcon sx={{ color: '#1e4f9b' }} />
                                        )}
                                    </ListItemButton>
                                </ListItem>
                                <Collapse in={projectsOpen} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {PROJECTS.map((project, projectIndex) => (
                                            <ListItem
                                                key={project}
                                                disablePadding
                                                onClick={() => handleNavigate(PROJECT_ROUTES[projectIndex])}
                                            >
                                                <ListItemButton sx={{ color: '#1e4f9b', pl: 4 }}>
                                                    <ListItemIcon>
                                                        <Box
                                                            component="img"
                                                            sx={{
                                                                height: 25,
                                                                width: 25,
                                                                position: 'relative',
                                                            }}
                                                            alt="Logo"
                                                            src={PROJECT_IMAGES_PATHS[projectIndex]}
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText primary={project} />
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Collapse>
                            </>
                        )}
                    </React.Fragment>
                ))}
            </List>
        </Box>
    );

    return (
        <div>
            <Drawer open={props.open} onClose={toggleDrawer(false)} anchor="right">
                {DrawerList}
            </Drawer>
        </div>
    );
}
